import { Outlet, createBrowserRouter } from "react-router-dom";
import App from "./App";
import AutenticationGuard from "components/authentication-guard/AuthenticationGuard";
import BusinessIdGuard from "components/BusinessIdGuard";
import DefaultLayout from "theme/Layout";
import LoginLayout from "theme/LoginLayout";
import Error from "pages/error/Error";
import ForgotPassword from "pages/forgot-password/ForgotPassword";
import Home from "pages/home";
import { applicationsLoader } from "pages/home/applicationsLoader";
import Collabs from "pages/collabs";
import { collabsLoader } from "pages/collabs/collabsLoader";
import { CollabDetail, CollabEdit } from "pages/collab";
import { collabLoader } from "pages/collab/collabLoader";
import CollabSuccess from "pages/collab/CollabSuccess";
import CampaignCreate from "pages/campaign/CampaignCreate";
import Influencer from "pages/influencers";
import { influencersLoader } from "pages/influencers/influencersLoader";
import Login from "pages/login";
import Messenger from "pages/messenger/Messenger";
import ChatRouteWrapper from "pages/messenger/ChatRouteWrapper";
import SuperMessenger from "pages/supermessenger/Messenger";
import NotFound from "pages/not-found";
import Onboarding from "pages/onboarding/Onboarding";
import Pricing from "pages/pricing/Pricing";
import Upgrade from "pages/pricing/Upgrade";
import CollabReport from "pages/report/CollabReport";
import Settings from "pages/settings/Settings";
import SigninSession from "pages/signin-session/SigninSession";
import Campaigns from "pages/campaigns/Campaigns";
import CampaignEditOffer from "pages/campaign/CampaignEditOffer";
import CampaignEditInstructions from "pages/campaign/CampaingEditInstructions";
import { campaignLoader } from "pages/campaign/campaingLoader";
import ChatPage from "pages/companion/ChatPage";
import Applications from "pages/applications/Applications";
import NewHome from "pages/home/NewHome";
import CreatorProfile from "pages/creator-profile/CreatorProfile";
import { creatorLoader } from "pages/influencers/creatorLoader";
import CreatorInvite from "pages/creator-invite/CreatorInvite";
import NewWelcome from "pages/onboarding/NewWelcome";
import TikTokAuth from "pages/tiktok-auth/TikTokAuth";
import FAQ from "pages/faq/FAQ";
import { PaywallProvider } from "components/paywall/paywallContext";
import PaywallHost from "components/paywall/PaywallHost";
import VerificationCode from "pages/verification/VerificationCode";
import SelfCampaignGuard from "pages/self-campaign/SelfCampaignGuard";
import SelfCampaignEntry from "pages/self-campaign/SelfCampaignEntry";
import SelfCampaignCreate from "pages/self-campaign/SelfCampaignCreate";
import SelfCampaignDesign from "pages/self-campaign/SelfCampaignDesign";
import SelfCampaignActivate from "pages/self-campaign/SelfCampaignActivate";
import {
  SELF_CAMPAIGN_BASE_PATH,
  WELCOME_BACK_BASE_PATH,
} from "pages/self-campaign/routePaths";
import MarketplaceDashboard from "pages/marketplace-dashboard/MarketplaceDashboard";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <App />
      </>
    ),
    errorElement: (
      <LoginLayout>
        <Error />
      </LoginLayout>
    ),
    children: [
      {
        element: (
          <PaywallProvider>
            <Outlet />
          </PaywallProvider>
        ),
        children: [
          {
            path: "/",
            element: (
              <AutenticationGuard>
                <DefaultLayout>
                  <BusinessIdGuard>
                    <PaywallHost />
                    <Outlet />
                  </BusinessIdGuard>
                </DefaultLayout>
              </AutenticationGuard>
            ),
            errorElement: (
              <DefaultLayout>
                <Error />
              </DefaultLayout>
            ),
            children: [
              // { path: "/", element: <Home />, loader: applicationsLoader },
              {
                path: "/",
                element: <NewHome />,
              },
              {
                path: "/welcome",
                element: <NewWelcome />,
              },
              {
                path: "/home",
                element: <Home />,
                loader: applicationsLoader,
              },
              {
                path: "/collabs",
                element: <Collabs />,
                loader: collabsLoader,
              },
              {
                path: "/collabs/:id",
                element: <CollabDetail />,
                loader: collabLoader,
              },
              {
                path: "/collab-success",
                element: <CollabSuccess />,
              },
              {
                path: "/report",
                element: <CollabReport />,
              },
              {
                path: "/collabs/:id/edit",
                element: <CollabEdit />,
                loader: collabLoader,
              },
              { path: "/collabs/new", element: <CollabEdit /> },
              { path: "/campaign/new", element: <CampaignCreate /> },
              {
                path: "/campaigns",
                element: <Campaigns />,
              },
              {
                path: "/campaigns/edit/offer/:id",
                element: <CampaignEditOffer />,
                loader: campaignLoader,
              },
              {
                path: "/campaigns/:id/edit-offer",
                element: <CampaignEditOffer />,
                loader: campaignLoader,
              },
              {
                path: "/campaigns/:id/edit-instructions",
                element: <CampaignEditInstructions />,
                loader: campaignLoader,
              },
              {
                path: "/applications",
                element: <Applications />,
                loader: influencersLoader,
              },
              {
                path: "/creators",
                element: <Influencer />,
              },
              {
                path: "/creators/:id",
                element: <CreatorProfile />,
                loader: creatorLoader,
              },
              {
                path: "/creators/:id/invite",
                element: <CreatorInvite />,
                loader: creatorLoader,
              },
              { path: "/messenger", element: <Messenger /> },
              { path: "/messenger/:id", element: <ChatRouteWrapper /> },
              { path: "/settings", element: <Settings /> },
              { path: "/upgrade", element: <Upgrade /> },
              {
                path: "/mustard-bot",
                element: <ChatPage />,
              },
              {
                path: "/faq",
                element: <FAQ />,
              },
            ],
          },
          {
            path: "/onboarding",
            element: <Onboarding />,
          },
          {
            path: SELF_CAMPAIGN_BASE_PATH,
            element: <SelfCampaignEntry />,
          },
          {
            path: `${SELF_CAMPAIGN_BASE_PATH}/design`,
            element: <SelfCampaignDesign />,
          },
          {
            path: `${SELF_CAMPAIGN_BASE_PATH}/activate`,
            element: <SelfCampaignActivate />,
          },
          {
            path: WELCOME_BACK_BASE_PATH,
            element: <SelfCampaignCreate />,
          },
          {
            path: `${WELCOME_BACK_BASE_PATH}/design`,
            element: <SelfCampaignDesign />,
          },
          {
            path: `${WELCOME_BACK_BASE_PATH}/activate`,
            element: <SelfCampaignActivate />,
          },
          {
            path: "/pricing",
            element: (
              <LoginLayout>
                <Pricing />
              </LoginLayout>
            ),
          },
          {
            path: "/login",
            element: (
              <LoginLayout>
                <Login />
              </LoginLayout>
            ),
          },
          {
            path: "/verify",
            element: (
              <SelfCampaignGuard enabledRedirectTo="/self-campaign">
                <LoginLayout>
                  <VerificationCode />
                </LoginLayout>
              </SelfCampaignGuard>
            ),
          },
          {
            path: "/supermessenger",
            element: (
              <LoginLayout>
                <SuperMessenger />
              </LoginLayout>
            ),
          },
          {
            path: "/tiktok-auth",
            element: (
              <LoginLayout>
                <TikTokAuth />
              </LoginLayout>
            ),
          },
          {
            path: "/forgot-password",
            element: (
              <LoginLayout>
                <ForgotPassword />
              </LoginLayout>
            ),
          },
          {
            path: "/report/export",
            element: <CollabReport />,
          },
          {
            path: "/signup-session",
            element: (
              <LoginLayout>
                <SigninSession />
              </LoginLayout>
            ),
          },
          {
            path: "/marketplace-dashboard",
            element: (
              <LoginLayout>
                <MarketplaceDashboard />
              </LoginLayout>
            ),
          },
        ],
      },
    ],
  },

  {
    path: "*",
    element: (
      <LoginLayout>
        <NotFound />
      </LoginLayout>
    ),
  },
]);

export default router;
